import React from 'react';

import { styled } from 'core/styles';
import { MaybeEither, toEither } from 'utils/either';
import { Rating, ratingToLetter } from 'domain/types';
import { ratingColors } from 'domain/utils/constants';

type RatingLiteralProps = {
  rating: MaybeEither<Rating>;
  colored?: boolean;
};

export function RatingLiteral({ rating, colored = false }: RatingLiteralProps) {
  return toEither(rating).fold(
    r => (
      <RatingLiteralElement rating={r} colored={colored}>
        {ratingToLetter(r)}
      </RatingLiteralElement>
    ),
    () => (
      <RatingLiteralElement rating="N/A" colored={colored}>
        -
      </RatingLiteralElement>
    ),
  );
}

const RatingLiteralElement = styled('span', {
  shouldForwardProp: prop => prop !== 'rating' && prop !== 'colored',
})<{
  rating: Rating | 'N/A';
  colored: boolean;
}>(({ rating, colored }) => ({
  lineHeight: 1,
  color: colored ? ratingColors[rating] : undefined,
}));
